module.exports = __webpack_public_path__ + "files/db9b554fe5f590130ece7bd92e605c7e.png";